import '../../styles/UserProfile.css';

import { Menu, MenuItem } from '@mui/material';
import React, { useState } from 'react';

import Label from '../atoms/Label';
import { PURCHASE_TOGGLE } from '../../constants/constants';
import useLogout from '../../hooks/useLogout';
import { useSelector } from 'react-redux';
import userIcon from '../../assets/user_profile.svg';

const UserProfile = ({ handleNavigation, setState, setActivePath }) => {
	const { firstName, lastName } = useSelector((state) => state.userDetails);
	const logOut = useLogout();

	// State to anchor the menu
	const [anchorEl, setAnchorEl] = React.useState(null);
	const open = Boolean(anchorEl);
	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = (event) => {
		setAnchorEl(null);
	};

	return (
		<div className="user-profile-container">
			<div className="user-profile-content" onClick={handleClick}>
				<img src={userIcon} alt="icon" className="user-profile-icon" />
				<span className="user-profile-name">
					{firstName} {lastName}
				</span>
			</div>
			<Menu
				id="profileMenu"
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
				MenuListProps={{
					'aria-labelledby': 'basic-button',
				}}
				disableScrollLock={true}
			>
				<MenuItem
					sx={{ width: '12.5rem' }}
					selected={false}
					onClick={(e) => {
						handleNavigation(e, '/user-detail');
						handleClose(e);
						setState(false);
					}}
				>
					Profile
				</MenuItem>
				{PURCHASE_TOGGLE && (
					<MenuItem
						sx={{ width: '12.5rem' }}
						selected={false}
						onClick={(e) => {
							handleClose(e);
							handleNavigation(e, '/user-profile');
							setState(false);
						}}
					>
						My Purchase
					</MenuItem>
				)}
				<MenuItem
					sx={{ width: '12.5rem' }}
					selected={false}
					onClick={(e) => {
						handleClose(e);
						logOut();
						setState(false);
					}}
				>
					Logout
				</MenuItem>
			</Menu>
		</div>
	);
};

export default UserProfile;
